export default "__VITE_ASSET__06a09127__"